import { Component, OnInit } from '@angular/core';
import { BaseDisplay } from 'src/app/View/BaseUI/BaseDisplay';
import { Router } from '@angular/router';
import { GuestUserService } from '../../../../../Service/GuestUserService';

@Component({
	selector: 'app-registered-component',
	templateUrl: './RegisteredFragmentComponent.html',
	styleUrls: ['./RegisteredFragmentComponent.scss'],
})
export class RegisteredFragmentComponent extends BaseDisplay {

	/**
	 * constructor
	 */
	constructor(public route: Router) {

		// Angulerのコンポーネントなので、上位を呼ぶ必要がある
		super();
	}

	/**
	 * 開始処理
	 */
	public async start() {

		// スワイプでロケーションバックを非活性にする
		this.disablePhoneSwipeBack();

	}


	public async onClickShowTop() {
		this.log('onClickShowTop');
		await this.route.navigate([''], {replaceUrl: true});
		window.location.reload();
	}
}
